import http from "./Http";

export default {
  //AIzaSyDvFCSCtnDR7fjAluBEkOdzcJIM_35h7UM
  immobilize(imei, user) {
    var url =
      "/gateway/vas/immobilize/activate/internal?imei=" +
      imei +
      "&user=" +
      user;

    return http
      .put(url)
      .then(response => {
        if (response.data.response.code && response.data.response.code != 0)
          throw new Error(response.data.response.message);

        return response.data.response.message;
      })
      .catch(e => {
        throw e.message;
      });
  },
  cancelImmobilize(imei, user) {
    var url =
      "/gateway/vas/immobilize/deactivate/internal?imei=" +
      imei +
      "&user=" +
      user;

    return http
      .put(url)
      .then(response => {
        console.log(response);
          if (response.data.response.code && response.data.response.code != 0)
              throw new Error(response.data.response.message);

          return response.data.response.message;

        return response.data.message;
      })
      .catch(e => {
        throw e.message;
      });
  }
};
